// import DragDropController from '@/js/Webmail/DragDrop/DragDropController';
export {WindowDragDropDirective as default}

const WindowDragDropDirective = {
  created(el, binding) {

    const hover_active = binding.value.hover_class_active || 'drag-over';

    el.onEnter = (event) => {
      event.preventDefault();

      if(!el.hover_count){
        el.hover_count = 0;
        el.classList.add(hover_active);
      }

      if(el.hover_count === 0 && binding.value['cb_dragenter']) {
         binding.value['cb_dragenter'](event);
      }

      el.hover_count++;
    }

    el.onDrop = (event) => {
      event.preventDefault();
      el.hover_count = 0;
      el.classList.remove(hover_active);

      if (binding.value['cb_drop']) {
        binding.value['cb_drop'](event);
      }
    };

    el.onLeave = (event) => {
      event.preventDefault();
      el.hover_count--

      if(el.hover_count !== 0){
        return;
      }

      el.classList.remove(hover_active);

      if (binding.value['cb_dragleave']) {
        binding.value['cb_dragleave'](event);
      }
    };

    el.onOver = (event) => {
      event.preventDefault();
    }
  },
  mounted(el) {
    el.addEventListener('drop'      , el.onDrop);
    el.addEventListener('dragover'  , el.onOver);
    el.addEventListener('dragenter' , el.onEnter);
    el.addEventListener('dragleave' , el.onLeave);
  },
  unmounted(el) {
    el.removeEventListener('dragover' , el.onEnter);
    el.removeEventListener('dragleave', el.onDrop);
    el.removeEventListener('drop'     , el.onLeave);
    el.removeEventListener('dragover' , el.onOver);
  },
};
